// extracted by mini-css-extract-plugin
export default {"checkout_summary":"Bx","checkout_summary_wrapper":"Cx","summary_items":"Ex","line_items_wrapper":"Fx","separator":"Gx","order_summary":"Hx","line_item":"Ix","order__summary_item_title":"Jx","recurringdis":"Kx","note":"Lx","carbon_emission":"Mx","unlock_savings":"Nx","member_perk":"Ox","info":"Px","no_items":"Qx","promo":"Rx","order_summary_mobile":"Sx","open_summary_mobile":"Tx","fixed_bottom_info":"Ux","open_info":"Vx","text":"Wx","open_summary":"Xx"};
    if(module.hot) {
      // 1714654886160
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  